import { Pie, PieChart, Tooltip, Legend, ResponsiveContainer } from 'recharts';


// const data = [
//   { name: 'Group A', value: 400, fill: '#8884d8' },
//   { name: 'Group B', value: 300, fill: '#459875' },
//   { name: 'Group C', value: 300, fill: '#987043' },
//   { name: 'Group D', value: 200, fill: '#342190' },
// ];

const PieChartSimple = ({data}) => {
  return (
    <div style={{ width: '100%', height: 400 }}>
    <ResponsiveContainer>
        <PieChart>
            <Tooltip />
            <Legend />
            <Pie dataKey="value" data={data} label />
        </PieChart>
        </ResponsiveContainer>
    {/* // <ResponsiveContainer width="100%" height={450}>
    //   <PieChart width={400} height={400}>
    //     <Tooltip />
    //     <Pie data={data01} dataKey="value" cx="50%" cy="50%" outerRadius={60} fill="#8884d8" />
    //     <Pie data={data02} dataKey="value" cx="50%" cy="50%" innerRadius={70} outerRadius={90} fill="#82ca9d" label />
    //   </PieChart>
    // </ResponsiveContainer> */}
    </div>
  );
};

export default PieChartSimple;

